import { selectAppDomain, useAppSelector } from '@ibk/shared-config';
import { AppDomain } from '@ibk/shared-types';
import { useGetAccountantEmissorBeneficiaryFiltersQuery, useGetClientEmissorBeneficiaryFiltersQuery, } from '../services/contractBeneficiariesApi';
export function useEmissorBeneficiaryFilters({ contractId, skip = false, }) {
    const appDomain = useAppSelector(selectAppDomain);
    const isAccountant = appDomain === AppDomain.ESCRITORIO;
    const shouldSkip = skip || !contractId;
    const queryArg = { contractId: contractId ?? '' };
    const accountantQuery = useGetAccountantEmissorBeneficiaryFiltersQuery(queryArg, {
        skip: shouldSkip || !isAccountant,
    });
    const clientQuery = useGetClientEmissorBeneficiaryFiltersQuery(queryArg, {
        skip: shouldSkip || isAccountant,
    });
    const activeQuery = isAccountant ? accountantQuery : clientQuery;
    return {
        filterOptions: activeQuery.data,
        isLoading: activeQuery.isLoading,
        isError: activeQuery.isError,
    };
}
